const COL_A = [1027, 1011, 1018, 1015, 1043, 433];
const COL_B = [1025, 1019, 1024, 669, 866, 870];
const COL_C = [881, 996, 119, 219, 447, 564];

const url = (id: number) => `https://picsum.photos/id/${id}/600/800`;

function Column({ ids, animation }: { ids: number[]; animation: string }) {
  const doubled = [...ids, ...ids];
  return (
    <div className="overflow-hidden rounded-md">
      <div className={`flex flex-col gap-3 ${animation} will-change-transform`}>
        {doubled.map((id, i) => (
          <img
            key={`${id}-${i}`}
            src={url(id)}
            alt=""
            loading="lazy"
            className="aspect-[3/4] w-full rounded-md bg-card object-cover brightness-95 saturate-[1.05]"
          />
        ))}
      </div>
    </div>
  );
}

export function HeroMarquee() {
  return (
    <div
      aria-hidden="true"
      className="relative grid h-full max-h-[calc(100vh-120px)] grid-cols-3 gap-3 overflow-hidden rounded-2xl"
      style={{
        maskImage: "linear-gradient(180deg, transparent 0%, #000 8%, #000 92%, transparent 100%)",
        WebkitMaskImage:
          "linear-gradient(180deg, transparent 0%, #000 8%, #000 92%, transparent 100%)",
      }}
    >
      <Column ids={COL_A} animation="animate-marquee-up" />
      <Column ids={COL_B} animation="animate-marquee-down-slow" />
      <Column ids={COL_C} animation="animate-marquee-up-slow" />
    </div>
  );
}
